import Vue from 'vue';
import VueI18n from 'vue-i18n';
import axios from 'axios';
import ro from '../../public/locale/ro.json';
import en from '../../public/locale/en.json';

Vue.use(VueI18n);

const defaultLocale = 'en';
const fallbackLocale = 'en';

const messages = {
  en,
  ro,
};

const loadedLanguages = ['en']; // our default language that is prelaoded

const i18n = new VueI18n({
  locale: defaultLocale,
  fallbackLocale,
  messages,
  silentTranslationWarn: true,
  missing: (locale, key, vm) => {
    if (process.env.NODE_ENV !== 'production') {
      if (locale != "en") {
        console.log("component=" + vm.$options.name + "; locale=" + locale + "; \"" + key + "\": \"\",");
      }
    }
  },
});

function setI18nLanguage(lang) {
  i18n.locale = lang;
  document.querySelector('html').setAttribute('lang', lang);
  return lang;
}

function loadLanguageAsync(lang) {
  if (i18n.locale !== lang) {
    if (!loadedLanguages.includes(lang)) {
      return axios.get(`/locale/${lang}.json`)
        .then((res) => {
          i18n.setLocaleMessage(lang, res.data);
          loadedLanguages.push(lang);
          return setI18nLanguage(lang);
        })
        .catch(() => {});
    }
    return Promise.resolve(setI18nLanguage(lang));
  }
  return Promise.resolve(lang);
}

export default i18n;
export {
  defaultLocale,
  loadLanguageAsync
};
